module.exports = "/assets/2c0cb6fe41042517d002d2325a459fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DJ.png
// module id = 1303
// module chunks = 0